//Document ready
$(function () {
	//meetingModalTrigger();

	$(".meeting-modal-day select").selectric();
	$(".meeting-modal-month select").selectric();
	$(".meeting-modal-time select").selectric();
});

//Meeting modal trigger
function meetingModalTrigger() {
	var meetingModalTriggers = document.querySelectorAll(".js-meeting-modal-trigger"),
		meetingModal = document.querySelector(".meeting-modal"),
		meetingModalMask = document.querySelector(".meeting-modal-mask"),
		meetingModalClose = document.querySelector(".meeting-modal-close"),
		i;

	for (i = 0; i < meetingModalTriggers.length; ++i) {
		meetingModalTriggers[i].addEventListener(
			"click",
			function () {
				meetingModal.classList.add("js-active");
			},
			false
		);
	}

	meetingModalMask.addEventListener(
		"click",
		function () {
			meetingModal.classList.remove("js-active");
		},
		false
	);

	meetingModalClose.addEventListener(
		"click",
		function () {
			meetingModal.classList.remove("js-active");
		},
		false
	);
}